import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllDateTableTask, updateTask } from '../../Redux/GetSlice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTaskData } from '../../hooks/useTaskData';

export default function MyDayPlanDropdown({
    currentTaskId,
    setSelectedMyDayPlanDate,
    selectedMyDayPlanDate,
    handleUpdateTask,
    isOpen,
    onClose,
    taskItem,
    taskId,
    type,
    getAllTask,
    handleDateSelect,
    setIsMyDayChecked,
    isMyDayChecked,
    clickedBellIcon
}) {
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();

    // Use the custom hook to get all task data from Redux
    const {
        // State values
        selectedMyDayPlanDate: reduxSelectedMyDayPlanDate,

        isMyDayChecked: reduxIsMyDayChecked,


        // Action functions
        updateSelectedMyDayPlanDate: updateSelectedMyDayPlanDateRedux,

        updateMyDayDate,
        updateIsMyDayChecked: updateIsMyDayCheckedRedux,


    } = useTaskData();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (onClose) {
                    onClose();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    const formatToLocalISO = (date) => {
        const pad = (num) => String(num).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
            date.getMinutes(),
        )}:00`;
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('en-US', {
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };

    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }

        return dateOption;
    };

    const handleReminderSelection = (dateOption) => {
        const date = getFormattedDate(dateOption);
        const formattedDate = formatToLocalISO(date);

        const taskToUpdate = type === 'DatePlan-Table' ? taskId || currentTaskId : taskItem?.id;

        // Use the handleDateSelect from props if available, otherwise use the hook's version
        // if (handleDateSelect) {
        //     handleDateSelect('myday', formattedDate, taskItem);
        // } else {
        //     handleDateSelectFromHook(formattedDate, 'myDay');
        // }

        // Update Redux state
        updateSelectedMyDayPlanDateRedux(formattedDate);
        updateMyDayDate(formattedDate);
        // handleDateSelectFromHook(formattedDate, 'myDay',taskItem);
        handleUpdateTask(formattedDate, 'myDay', taskItem);

        if (type === 'DatePlan-Table') {
            dispatch(
                updateTask({
                    newDate: date.toISOString(),
                    type: 'myDayPlan',
                    taskItem: taskToUpdate,
                }),
            );
            dispatch(getAllDateTableTask());
        }

        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        if (selectedMyDayPlanDate) {
            const date = new Date(selectedMyDayPlanDate);
            setCustomDate(date);
        }
    }, [selectedMyDayPlanDate]);

    const handleDateChange = (date) => {
        setCustomDate(date);
        setShowDatePicker(false);
        handleReminderSelection(date);
    };

    const handleClearSelection = () => {
        // Update Redux state
        updateSelectedMyDayPlanDateRedux(null);
        updateMyDayDate(null);

        // Also update props if available
        if (setSelectedMyDayPlanDate) {
            setSelectedMyDayPlanDate(null);
        }

        const taskToUpdate = type === 'DatePlan-Table' ? taskId || currentTaskId : taskItem?.id;
        dispatch(
            updateTask({
                newDate: null,
                type: 'myDayPlan',
                taskItem: taskToUpdate,
            }),
        );
        if (type === 'DatePlan-Table') {
            dispatch(getAllDateTableTask());
        }
        if (onClose) onClose();
    };

    // Pre-defined date options
    const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
    const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
    const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
    const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };

    // Use Redux state values, fallback to props if needed
    const currentIsMyDayChecked = reduxIsMyDayChecked !== undefined ? reduxIsMyDayChecked : isMyDayChecked;
    const currentSetIsMyDayChecked = updateIsMyDayCheckedRedux || setIsMyDayChecked;

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            {isOpen && (
                <div
                    // className="relative z-30" style={{ minWidth: 260 }}
                    className={`${clickedBellIcon ? 'fixed z-30' : 'relative z-30'}`}

                    style={clickedBellIcon ? { top: '50px', right: "2vw", minWidth: 260 } : { minWidth: 260 }}
                >
                    <div className="bg-white rounded-lg shadow-lg border border-gray-100 p-0" style={{ width: 260 }}>
                        <div className="flex items-center justify-between px-2 pt-2 pb-1 border-b border-gray-100">
                            <span className="font-semibold text-[15px] text-gray-900">Add to My Day plan...</span>
                            <button
                                onClick={handleClearSelection}
                                className="text-[#2196f3] text-xs font-medium hover:underline p-0 m-0 bg-transparent border-none outline-none"
                            >
                                Clear
                            </button>
                        </div>

                        {/* Options List */}
                        <ul className="text-xs text-gray-800 divide-y divide-gray-100 px-0 mb-0">
                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(today)}

                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-sun-fill text-gray-900"></i>
                                    <span className="text-xs">Later today</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(today))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(tomorrow)}
                            // onClick={() => handleDateSelect('myday', tomorrow)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-moon-stars-fill text-gray-500"></i>
                                    <span className="text-xs">Tomorrow</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(tomorrow))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(inTwoDays)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-clock-fill text-gray-500"></i>
                                    <span className="text-xs">In two days</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(inTwoDays))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(nextWeek)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-week-fill text-gray-500"></i>
                                    <span className="text-xs">Next week</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(nextWeek))}
                                </span>
                            </li>

                            <li
                                className="flex items-center px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => setShowDatePicker(!showDatePicker)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-event-fill text-gray-500"></i>
                                    <span className="text-xs">Pick a date</span>
                                </span>
                            </li>
                        </ul>

                        {showDatePicker && (
                            <div className="absolute left-[48%] top-0 mt-2 z-50 bg-white border border-gray-200 rounded shadow-lg" style={{ transform: 'translateX(-50%)', width: 320 }}>

                                <DatePicker
                                    selected={customDate}
                                    onChange={(date) => setCustomDate(date)}
                                    showTimeSelect
                                    timeFormat="hh:mm aa"
                                    timeIntervals={15}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    placeholderText="Select date and time"
                                    inline
                                    minDate={new Date()}
                                />
                                <div className="flex  items-center mt-2 px-2" style={{ gap: '10px' }}>
                                    <button
                                        className="text-blue-600 text-xs font-medium hover:underline px-2 py-1 rounded"
                                        onClick={() => setCustomDate(new Date())}
                                        type="button"
                                    >
                                        ▼ Today
                                    </button>
                                    <button
                                        className="text-red-500 text-xs font-medium hover:underline px-2 py-1 rounded"
                                        onClick={() => setCustomDate(null)}
                                        type="button"
                                    >
                                        ✗ Clear
                                    </button>
                                    <button
                                        className="text-green-600 text-xs font-medium hover:underline px-2 py-1 rounded border border-green-600"
                                        onClick={() => {
                                            if (customDate) {
                                                handleDateChange(customDate);
                                            }
                                        }}
                                        type="button"
                                    >
                                        ✔ Save
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="px-2 pt-2 pb-3">
                            <label className="flex items-center gap-2 text-xs text-gray-800">
                                <input
                                    type="checkbox"
                                    className="form-checkbox rounded border-gray-300"
                                    checked={currentIsMyDayChecked}
                                    onChange={e => currentSetIsMyDayChecked(e.target.checked)}
                                />
                                Also update the deadline date
                            </label>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}